import Request from 'gd-request';

class ApiGantt {

    constructor() {

    }

    updateItems(items) {
        return new Request(this,'put','timeline/update',{
            data: items
        });
    }

}


module.exports = ApiGantt;